<section class="bg-white intro">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 px-0 termekek">
        <section class="bg-white text-primary mt-5 mb-4 py-4">
          <div class="container pt-5">
            <div class="row pt-4">
              <div class="col-12 col-lg-10">
                <h1 class="bold">HÍREK, AKTUALÍTÁSOK</h1>
              </div>
            </div>
          </div>
        </section>
        <section class="bg-white mb-4 py-4 article-section">
          <div class="container">
            <div class="row justify-content-center">

              <div class="hirDiv">
                <p><b>Tisztelt Ügyfelünk!</b></p>
                <p>
                  Tájékoztatjuk, hogy a Gránit Biztosító Zrt. 2025. július 01-től új irodába költözik.<br />Ennek következtében megváltozik a Biztosító székhelye és a személyes ügyintézés helyszíne.
                </p>
                <p>
                  Ügyfélszolgálat új címe: 1134 Budapest, Váci út 17.
                </p>
                <p>
                  A 1211 Budapest, Szállító u. 4. szám alatti ügyfélszolgálati iroda 2025. június 27-én (pénteken) 15:00-kor végleg bezár.<br />2025. június 30-án (hétfőn) a személyes ügyfélfogadás szünetel.
                </p>
                <p>Egyéb elérhetőségeink nem változnak.</p>
                <p>Telefonos elérhetőség: +36-1-666-6200; +36-1-9999-999</p>
                <p>Kárbejelentés:<br /><a href="#" id="emailKar" class="email-button">Email küldése</a></p>                
                <p>Változásbejelentés:<br /><a href="#" id="emailValtozas" class="email-button">Email küldése</a></p>
                <p>Panaszbejelentés:<br /><a href="#" id="emailPanasz" class="email-button">Email küldése</a></p>
                <p>Weboldal: <a href="https://www.granitbiztosito.hu" target="_blank">www.granitbiztosito.hu</a></p>
                <p>
                  Reméljük, hogy Ön(ök) is bizalommal tekintenek jövőbeli közös kapcsolatunk elé, és bízunk abban, hogy új
                  helyszínünkön is a korábbiakban megszokott legmagasabb színvonalon tudjuk Önöket kiszolgálni.
                </p>
                <p>
                  Szeretettel várjuk új irodánkban!
                </p>
                <p>
                  Gránit Biztosító Zrt.
                </p>
              </div>

              <div class="hirDiv">
                <p><b>Tisztelt Ügyfeleink!</b></p>
                <p>
                  A Gránit Biztosító elkötelezett abban, hogy ügyfeleink igényeihez alkalmazkodó lakásbiztosításaink maximális védelmet nyújtsanak és fedezzék mindazon költségeket, amelyek egy esetleges kár helyreállítása során felmerülnek. Abban is elkötelezettek vagyunk, hogy ezt a biztosítási védelmet - mint az egyik legköltséghatékonyabban működő biztosító - versenyképes díjon kínáljuk. Mindig arra törekedtünk, hogy díjaink növekedése jóval kisebb legyen, mint a biztosított épületek és vagyontárgyak értékének növekedése, ezzel is támogatva az infláció csökkentése irányába tett lépéseket.
                </p>
                <p>
                  Örömmel tájékoztatjuk Önöket, hogy a Gránit Biztosító a Nemzetgazdasági Minisztérium ezirányú kérését meghallgatva önként vállalta, hogy meglévő laklásbiztosítási szerződéseinek díját 2025.
                  július 1-jét követően 2026. június 30-ig nem módosítja. A biztosítási díjak változatlanul hagyása mellett a biztosított épületek és vagyontárgyak szerződésben meghatározott értékét (biztosítási
                  összegét) továbbra is az inflációt figyelembe véve emeljük, ezzel biztosítjuk a szerződések értékállóságát, és azt, hogy azok továbbra is a vagyontárgyak tényleges értékének megfelelő védelmet nyújtsanak. A biztosítási díj változatlanul hagyása a 2025. július 1-jei, illetve azutáni biztosítási évfordulóval rendelkező szerződéseinkre terjed ki.
                </p>
                <p>
                  A biztosító azt is vállalja, hogy az új szerződést kötő ügyfeleink részére kínált lakásbiztosítási díjak nem haladják meg a 2024-ben szerződést kötő ügyfelek díjait.
                </p>
                <p>Amennyiben Ön lakásbiztosítással rendelkező ügyfelünk, és biztosítási évfordulója 2025. július 1-je után lesz, külön teendője nincs a biztosítás díjának változatlanul tartása érdekében. Amennyiben kapott már Társaságunktól a július 1-jei utáni évfordulótól érvényes új díjról szóló tájékoztatást, kérjük, azt tekintse tárgytalannak.</p>
              </div>

              <div class="hirDiv">
                <p><b>Tájékoztatás!</b></p>
                <p>
                  Február 15-től új névvel és arculattal, Gránit Biztosítóként folytatja a működését a Wáberer Hungária Biztosító, amely a Gránit Bankkal kötött stratégiai együttműködési megállapodásának köszönhetően a pénzintézet szakmai hátterére is építhet a jövőben, illetve a bank széles ügyfélköre számára válnak elérhetővé biztosítási termékei. A Gránit Biztosító megújult arculatának bevezetése, illetve az új honlapjának indítása február második felében valósul meg. A biztosítóval korábban megkötött szerződések változatlan feltételekkel és tartalommal élnek tovább, ugyanolyan professzionális ügyfélkiszolgálás és változatlan, erős szakmai háttér mellett.
                </p>
                <p>Üdvözlettel,</p>
                <p>
                  Gránit Biztosító Zrt.
                </p>
              </div>

              <div class="hirDiv">
                <p><b>Tisztelt Ügyfeleink!</b></p>
                <p>
                  Önök előtt is ismert, hogy az európai szanálási hatóság végelszámolást indított a magyar Sberbank anyavállalatánál, az osztrák Sberbank Europe AG-nál, mely kedvezőtlenül érinti a Sberbank Magyarország Zrt-t is.
                  A Sberbank Magyarország Zrt.től, a bank likviditási és tőkehelyzete miatt az MNB visszavonta a hazai hitelintézet tevékenységi engedélyét és elrendelte annak végelszámolását.<br />
                  Az előbbiek miatt Társaságunknak nem áll módjában Sberbank Magyarország Zrt-nél vezetett bankszámlaszámára utalást indítani, ezért amennyiben Társaságunktól bármilyen okból forint utalást várt, legyen szíves megadni <a [routerLink]="['/kapcsolat']">elérhetőségeink valamelyikén</a> az új bankszámlaszámát, melyre kötelezettségünket teljesíteni tudjuk.
                </p>
                <p>Üdvözlettel,</p>
                <p>
                  Gránit Biztosító Zrt.
                </p>
              </div>

              <div class="hirDiv">
                <p><b>Tisztelt Ügyfeleink!</b></p>
                <p>
                  Felhívjuk a figyelmet arra, hogy a Külügyminisztérium Konzuli Szolgálata 2022. február 24-étől Ukrajna teljes területét a kialakult háborús helyzet miatt az utazásra nem javasolt biztonsági kategóriába sorolta.<br />
                  A szerződési feltételeink alább idézett rendelkezése értelmében a Gránit Biztosító Zrt. utasbiztosításainak területi hatálya 2022. február 24-i vagy későbbi beutazás esetén nem terjed ki Ukrajna területére.<br />
                  „A kockázatviselés nem terjed ki olyan térségekre, amelyek a kockázatviselés első napján, vagy a biztosított által az adott területre való beutazás napján a Külgazdasági és Külügyminisztérium által meghatározott utazásra nem javasolt utazási térségek között szerepelnek.”
                </p>
                <p>Üdvözlettel,</p>
                <p>
                  Gránit Biztosító Zrt.
                </p>
              </div>

            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
